// DoctorDetailPage.jsx - Updated Layout with Public Profile Tab
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import adminService from '../../services/adminService';
import RegistrationTab from './DoctorRegistrationTab';
import DoctorPatientsTab from './DoctorPatientsTab';
import DoctorPublicProfileTab from './DoctorPublicProfileTab';
import '../../styles/components/admin/DoctorDetailsPage.css';

const DoctorDetailPage = () => {
  const { doctorId } = useParams();
  const navigate = useNavigate();
  
  const [activeTab, setActiveTab] = useState(0);
  const [doctor, setDoctor] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  useEffect(() => {
    loadDoctorData();
  }, [doctorId]);
  
  const loadDoctorData = async () => {
    setLoading(true);
    try {
      console.log('🔵 FETCHING doctor details for ID:', doctorId);
      const response = await adminService.getDoctorDetails(doctorId);
      console.log('✅ RAW API RESPONSE:', response);
      
      if (response && response.data) {
        setDoctor(response.data);
      } else if (response) {
        setDoctor(response);
      } else {
        throw new Error('Invalid response format');
      }
    } catch (error) {
      console.error('Error loading doctor data:', error);
      setError('Failed to load doctor details. Please try again later.');
      toast.error('Failed to load doctor details');
    } finally {
      setLoading(false);
    }
  };
  
  if (loading) {
    return (
      <div className="doctor-detail-loading">
        <div className="loading-spinner"></div>
        <p>Loading doctor details...</p>
      </div>
    );
  }
  
  if (error || !doctor) {
    return (
      <div className="doctor-detail-error">
        <h3>Error</h3>
        <p>{error || 'Doctor not found'}</p>
        <button className="back-button" onClick={() => navigate(-1)}>Go Back</button>
      </div>
    );
  }

  // Get verification status display text
  const getStatusDisplay = () => {
    if (!doctor.verificationStatus) return 'Pending';
    return doctor.verificationStatus.charAt(0).toUpperCase() + doctor.verificationStatus.slice(1);
  };
  
  // Get verification status class
  const getStatusClass = () => {
    if (!doctor.verificationStatus) return 'status-pending';
    return `status-${doctor.verificationStatus.toLowerCase()}`;
  };
  
  return (
    <div className="doctor-detail-page">
      {/* Doctor Info Bar with Back Button */}
      <div className="doctor-info-bar">
        <div className="doctor-primary-info">
          {/* Back button and doctor info in same container */}
          <div className="doctor-header-left">
            <button 
              className="admin-doctor-detail-back-button"
              onClick={() => navigate(-1)}
              title="Go back"
            >
              <span>←</span>
            </button>
            <div className="doctor-name-email">
              <h1 className="doctor-name">{doctor.firstName} {doctor.lastName}</h1>
              <p className="doctor-email">{doctor.email}</p>
            </div>
          </div>
        </div>
        
        <div className="doctor-secondary-info">
          <span className={`doctor-status ${getStatusClass()}`}>
            {getStatusDisplay()}
          </span>
          <span className="doctor-verification-date">
            <strong>Verification Date:</strong> {doctor.verificationDate 
              ? new Date(doctor.verificationDate).toLocaleDateString('en-US', { 
                  year: 'numeric', 
                  month: 'long', 
                  day: 'numeric' 
                }) 
              : 'N/A'}
          </span>
        </div>
      </div>
      
      {/* Tabs Navigation */}
      <div className="doctor-tabs-container">
        <div className="doctor-tabs-nav">
          <button
            className={`tab-button ${activeTab === 0 ? 'active' : ''}`}
            onClick={() => setActiveTab(0)}
          >
            Registration
          </button>
          
          <button
            className={`tab-button ${activeTab === 1 ? 'active' : ''}`}
            onClick={() => setActiveTab(1)}
          >
            Patients
          </button>
          
          <button
            className={`tab-button ${activeTab === 2 ? 'active' : ''}`}
            onClick={() => setActiveTab(2)}
          >
            Public Profile
          </button>
        </div>
        
        {/* Tab Content */}
        <div className="doctor-tabs-content">
          {activeTab === 0 && (
            <div className="tab-panel">
              <RegistrationTab doctor={doctor} />
            </div>
          )}
          
          {activeTab === 1 && (
            <div className="tab-panel">
              <DoctorPatientsTab doctorId={doctorId} />
            </div>
          )}
          
          {activeTab === 2 && (
            <div className="tab-panel">
              <DoctorPublicProfileTab doctor={doctor} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DoctorDetailPage;